export default "__VITE_ASSET__BXCXpuml__"